import * as THREE from "three";

class GuideLines {
    constructor(building, scene, objects = null) {
        // walls, floor !?
        this._objects = objects; //objects
        this._building = building;
        this._scene = scene;
        this.lines = {};
        this._active = null;
        //this.lineWidth = 5
    }
    init() {
        const lineSizesMaterial = new THREE.LineBasicMaterial({ color: 0x000000 });

        const points_r = [new THREE.Vector3(), new THREE.Vector3(this._building.maxX, 0.05, 0)];
        const line_r = new THREE.Line(new THREE.BufferGeometry().setFromPoints(points_r), lineSizesMaterial);
        line_r.name = "Guide_Line_R";
        this._scene.add(line_r);
        this.lines["R"] = line_r;

        const points_l = [new THREE.Vector3(), new THREE.Vector3(this._building.minX, 0.05, 0)];
        const line_l = new THREE.Line(new THREE.BufferGeometry().setFromPoints(points_l), lineSizesMaterial);
        line_l.name = "Guide_Line_L";
        this._scene.add(line_l);
        this.lines["L"] = line_l;

        const points_t = [new THREE.Vector3(), new THREE.Vector3(0, 0.05, this._building.minZ)];
        const line_t = new THREE.Line(new THREE.BufferGeometry().setFromPoints(points_t), lineSizesMaterial);
        line_t.name = "Guide_Line_T";
        this._scene.add(line_t);
        this.lines["T"] = line_t;

        const points_b = [new THREE.Vector3(), new THREE.Vector3(0, 0.05, this._building.maxZ)];
        const line_b = new THREE.Line(new THREE.BufferGeometry().setFromPoints(points_b), lineSizesMaterial);
        line_b.name = "Guide_Line_B";
        this._scene.add(line_b);
        this.lines["B"] = line_b;

        line_r.computeLineDistances();
        line_l.computeLineDistances();
        line_t.computeLineDistances();
        line_b.computeLineDistances();

        this.hideLines();
    }

    findNeighbours(activeObject) {
        if (servObj.isRedactorMode || servObj.isEditMode) return;

        // this_activeObject and then rewrite cativeObject
        this._active = activeObject;
        const neighbours = {
            left: { distance: Infinity, object: null },
            right: { distance: Infinity, object: null },
            top: { distance: Infinity, object: null },
            bottom: { distance: Infinity, object: null },
        };

        //if(!activeObject)
        activeObject.updateWorldMatrix(true, false);
        const activeBox = this._getBoundaryBox(activeObject);

        const activeSize = {
            x: activeBox.max.x - activeBox.min.x,
            z: activeBox.max.z - activeBox.min.z,
        };

        const activePos = {
            x: (activeBox.min.x + activeBox.max.x) / 2,
            z: (activeBox.min.z + activeBox.max.z) / 2,
        };

        this._objects = this._building._all.concat(this._building.walls);
        this._objects.forEach((object) => {
            if (object === activeObject) return;

            object.updateWorldMatrix(true, false);
            const objectBox = this._getBoundaryBox(object);

            if (this._boxesIntersectXZ(activeBox, objectBox)) return;

            const objectSize = {
                x: objectBox.max.x - objectBox.min.x,
                z: objectBox.max.z - objectBox.min.z,
            };

            const objectPos = {
                x: (objectBox.min.x + objectBox.max.x) / 2,
                z: (objectBox.min.z + objectBox.max.z) / 2,
            };

            this._checkDirection("left", activePos, activeSize, objectPos, objectSize, object, neighbours);
            this._checkDirection("right", activePos, activeSize, objectPos, objectSize, object, neighbours);
            this._checkDirection("top", activePos, activeSize, objectPos, objectSize, object, neighbours);
            this._checkDirection("bottom", activePos, activeSize, objectPos, objectSize, object, neighbours);
        });

        return neighbours;
    }

    _boxesIntersectXZ(box1, box2) {
        return !(
            box1.max.x < box2.min.x ||
            box1.min.x > box2.max.x ||
            box1.max.z < box2.min.z ||
            box1.min.z > box2.max.z
        );
    }

    _checkDirection(direction, active, activeSize, objPos, objSize, obj, neighbours) {
        let condition = false;
        let distance = Infinity;

        switch (direction) {
            case "left":
                condition =
                    objPos.x + objSize.x / 2 <= active.x - activeSize.x / 2 &&
                    objPos.z + objSize.z / 2 > active.z &&
                    objPos.z - objSize.z / 2 < active.z;
                distance = active.x - activeSize.x / 2 - (objPos.x + objSize.x / 2);
                break;

            case "right":
                condition =
                    objPos.x - objSize.x / 2 >= active.x + activeSize.x / 2 &&
                    objPos.z + objSize.z / 2 > active.z &&
                    objPos.z - objSize.z / 2 < active.z;
                distance = objPos.x - objSize.x / 2 - (active.x + activeSize.x / 2);
                break;

            case "top":
                condition =
                    objPos.z - objSize.z / 2 >= active.z + activeSize.z / 2 &&
                    objPos.x + objSize.x / 2 > active.x &&
                    objPos.x - objSize.x / 2 < active.x;
                distance = objPos.z - objSize.z / 2 - (active.z + activeSize.z / 2);
                break;

            case "bottom":
                condition =
                    objPos.z + objSize.z / 2 <= active.z - activeSize.z / 2 &&
                    objPos.x + objSize.x / 2 > active.x &&
                    objPos.x - objSize.x / 2 < active.x;
                distance = active.z - activeSize.z / 2 - (objPos.z + objSize.z / 2);
                break;
        }

        if (condition && distance < neighbours[direction].distance) {
            neighbours[direction] = {
                object: obj,
                distance: distance,
            };
        }
    }

    recalculateLinesPosition(object, neighboursObj) {
        if (servObj.isRedactorMode || servObj.isEditMode) return;

        this._active = object;

        if (neighboursObj.bottom.object == null) {
            neighboursObj.bottom.object = this._building.wallBottom;
            neighboursObj.bottom.distance = 0;
        }

        // Получаем bounding box только для нижних элементов
        const box = this._getBoundaryBox(object);
        const size = box.getSize(new THREE.Vector3());

        // Центр для нижних элементов
        const center = box.getCenter(new THREE.Vector3());

        this._scene.children.forEach((child) => {
            if (child.name.includes("Guide_Line")) {
                const side = child.name.split("_")[2];
                const line = this.lines[side];

                let newPoints;

                if (side === "R") {
                    const distance = Number.isFinite(neighboursObj.right.distance) ? neighboursObj.right.distance : 0;
                    newPoints = [
                        new THREE.Vector3(center.x + size.x / 2, 0.05, center.z), // Начало луча от правого края нижних элементов
                        new THREE.Vector3(center.x + distance + size.x / 2, 0.05, center.z),
                    ];
                    this.lines["R"].children[0].position.x = center.x + distance / 2 + size.x / 2;
                    this.lines["R"].children[0].position.z = center.z;

                    const displayDistance = Number(distance.toFixed(4)) <= 0.0008 ? 0 : Math.round(distance * 1000);
                    this.lines["R"].children[0].element.lastChild.value = Number.isFinite(displayDistance)
                        ? displayDistance
                        : 0;
                }
                if (side === "L") {
                    const distance = Number.isFinite(neighboursObj.left.distance) ? neighboursObj.left.distance : 0;
                    newPoints = [
                        new THREE.Vector3(center.x - size.x / 2, 0.05, center.z), // Начало луча от левого края нижних элементов
                        new THREE.Vector3(center.x - distance - size.x / 2, 0.05, center.z),
                    ];
                    this.lines["L"].children[0].position.x = center.x - distance / 2 - size.x / 2;
                    this.lines["L"].children[0].position.z = center.z;

                    const displayDistance = Number(distance.toFixed(4)) <= 0.0008 ? 0 : Math.round(distance * 1000);
                    this.lines["L"].children[0].element.lastChild.value = Number.isFinite(displayDistance)
                        ? displayDistance
                        : 0;
                }
                if (side === "T") {
                    const distance = Number.isFinite(neighboursObj.top.distance) ? neighboursObj.top.distance : 0;
                    newPoints = [
                        new THREE.Vector3(center.x, 0.05, center.z + size.z / 2), // Начало луча от верхнего края нижних элементов
                        new THREE.Vector3(center.x, 0.05, center.z + distance + size.z / 2),
                    ];
                    this.lines["T"].children[0].position.z =
                        center.z -
                        (Number.isFinite(neighboursObj.bottom.distance) ? neighboursObj.bottom.distance : 0) / 2 -
                        size.z / 2;
                    this.lines["T"].children[0].position.x = center.x;

                    const bottomDistance = Number.isFinite(neighboursObj.bottom.distance)
                        ? neighboursObj.bottom.distance
                        : 0;
                    const displayDistance =
                        Number(bottomDistance.toFixed(4)) <= 0.0008 ? 0 : Math.round(bottomDistance * 1000);
                    this.lines["T"].children[0].element.lastChild.value = Number.isFinite(displayDistance)
                        ? displayDistance
                        : 0;
                }
                if (side === "B") {
                    const distance = Number.isFinite(neighboursObj.bottom.distance) ? neighboursObj.bottom.distance : 0;
                    newPoints = [
                        new THREE.Vector3(center.x, 0.05, center.z - size.z / 2), // Начало луча от нижнего края нижних элементов
                        new THREE.Vector3(center.x, 0.05, center.z - distance - size.z / 2),
                    ];
                    this.lines["B"].children[0].position.z =
                        center.z +
                        (Number.isFinite(neighboursObj.top.distance) ? neighboursObj.top.distance : 0) / 2 +
                        size.z / 2;
                    this.lines["B"].children[0].position.x = center.x;

                    const topDistance = Number.isFinite(neighboursObj.top.distance) ? neighboursObj.top.distance : 0;
                    const displayDistance =
                        Number(topDistance.toFixed(4)) <= 0.0008 ? 0 : Math.round(topDistance * 1000);
                    this.lines["B"].children[0].element.lastChild.value = Number.isFinite(displayDistance)
                        ? displayDistance
                        : 0;
                }

                line.geometry = new THREE.BufferGeometry().setFromPoints(newPoints);
                line.computeLineDistances();
            }
        });
    }
    _getBoundaryGeometry(obj) {
        // Собираем только нижние элементы (исключая верхние)
        const elements = [];
        const isOsnovanie = (name) => /^.+__osnovanie__\d+x\d+__\d+$/.test(name);
        obj.traverse((child) => {
            if (child === obj) return; // сам объект добавим отдельно ниже
            if (child.userData?.position === "top") return; // пропускаем верхние элементы
            if (child.userData?.position === "bottom" || isOsnovanie) {
                elements.push(child);
            }
        });

        // Всегда учитываем сам стол (obj)
        elements.push(obj);

        // Считаем bounding box только по выбранным элементам
        const box = new THREE.Box3().makeEmpty();
        elements.forEach((el) => {
            box.expandByObject(el);
        });

        // Если box пустой (например, obj не имеет геометрии), fallback на setFromObject
        if (box.isEmpty()) {
            box.setFromObject(obj);
        }

        return box.getSize(new THREE.Vector3());
    }
    _getBoundaryBox(obj) {
        const elements = [];

        // Шаблон: bazovii__osnovanie__1200x700__1815
        const isExcludedOsnovanie = (name) => /^.+__osnovanie__\d+x\d+__\d+$/.test(name);

        obj.traverse((child) => {
            if (child === obj) return; // Пропускаем сам объект
            if (child.userData?.position === "top") return; // Пропускаем верхние элементы
            if (isExcludedOsnovanie(child.name)) return; // Пропускаем неподходящие "основания"
            if (!child.visible) return; // Пропускаем скрытые элементы

            if (child.userData?.position === "bottom" || (child.name && child.name.includes("osnovanie"))) {
                elements.push(child);
            }
        });

        // Добавляем сам obj, только если он не исключён
        if (!isExcludedOsnovanie(obj.name)) {
            elements.push(obj);
        }

        const box = new THREE.Box3().makeEmpty();
        elements.forEach((el) => {
            el.updateWorldMatrix(true, false); // Обновляем матрицу
            box.expandByObject(el);
        });

        return box;
    }

    showLines() {
        for (let line in this.lines) this.lines[line].visible = true;
    }

    hideLines() {
        for (let line in this.lines) this.lines[line].visible = false;

        // servObj.building.restoreObjectColor();
    }

    setPointerEvents(val) {
        for (let line in this.lines) this.lines[line].children[0].element.lastChild.style.pointerEvents = val;
    }

    updateSceneByInputEnter(line, value) {
        if (value == 0) value = 0.01;

        const neighboursObj = this.findNeighbours(this._active);
        const lineCode = line.name.split("_")[2];

        if (lineCode == "R") {
            if (Number(value / 1000) - neighboursObj.right.distance > neighboursObj.left.distance) {
                this._active.position.x -= neighboursObj.left.distance - 0.00000001;
            } else {
                this._active.position.x += neighboursObj.right.distance - Number(value) / 1000;
            }
        }
        if (lineCode == "L") {
            if (Number(value / 1000) - neighboursObj.left.distance > neighboursObj.right.distance) {
                this._active.position.x += neighboursObj.right.distance - 0.00000001;
            } else {
                this._active.position.x -= neighboursObj.left.distance - Number(value) / 1000;
            }
        }
        if (lineCode == "T") {
            if (Number(value / 1000) - neighboursObj.bottom.distance > neighboursObj.top.distance) {
                this._active.position.z += neighboursObj.top.distance - 0.00000001;
            } else {
                this._active.position.z -= neighboursObj.bottom.distance - Number(value) / 1000;
            }
        }
        if (lineCode == "B") {
            if (Number(value / 1000) - neighboursObj.top.distance > neighboursObj.bottom.distance) {
                this._active.position.z -= neighboursObj.bottom.distance - 0.00000001;
            } else {
                this._active.position.z += neighboursObj.top.distance - Number(value) / 1000;
            }
        }

        this.recalculateLinesPosition(this._active, this.findNeighbours(this._active));
    }
}

export default GuideLines;
